export default __webpack_public_path__ + "static/Cover-d163230f8ed5fa58d6acb03a475aa8fd.png";